var angular = require('angular');
angular.module('pitch.search')
    // .factory('Label', function(config, $resource) {
    //     return $resource(config.apiUri + '/labels/:id', {
    //         id: '@id'
    //     }, {
    //         query: {
    //             method: 'GET',
    //             isArray: true,
    //             cache: true
    //         },
    //         get: {
    //             method: 'GET',
    //             cache: true
    //         }
    //     });
    // })

    //probably just need users labelz
    .factory('UserLabel', function(config, $resource) {
        return $resource(config.apiUri + '/session/user/labels', {}, {
            get: {
                method: 'GET',
                isArray: true,
                cache: true
            }
        });
    })

;



// WEBPACK FOOTER //
// ./src/SearchClientBundle/Resources/js/angular/services/Label.js